import { render, staticRenderFns } from "./CarTimeConfig.vue?vue&type=template&id=397d3ad5&scoped=true"
import script from "./CarTimeConfig.vue?vue&type=script&lang=js"
export * from "./CarTimeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d3ad5",
  null
  
)

export default component.exports